import { toast } from 'sonner';

// Shown when an individual (contributor) user tries to open a conversation
// that isn't assigned to them or one of their departments. The webchat API
// signals this with `accessDenied: true` on conversation fetches.
export const notifyConversationAccessDenied = (): void => {
	toast.error("Sorry, you don't have access to this conversation");
};
